module.exports = {"ticketView":"工单查看","announcementDetail":"公告详情"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-CN/mixins.json
// module id = lKwY
// module chunks = 1